import { useCallback, useEffect, useState } from "react";
import { PromiseToPayService } from "../services/PromiseToPayService";

export const useHookPromiseToPay = () => {
    const [data, setData] = useState([]);
    const [meta, setMeta] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // [PERBAIKAN] Ubah 'keyword' menjadi 'search' agar cocok dengan Backend ($request->search)
    const [params, setParams] = useState({
        search: "",      // Dulu: keyword
        nas_id: "",
        pop_id: "",
        odc_id: "",
        odp_id: "",
        status: "",      // Akan menampung nilai seperti 'terlewat', 'lunas', dll
        page: 1,
        per_page: 10,
        sort_field: "date",
        sort: "desc",
    });

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);

        // Bersihkan parameter yang kosong agar tidak mengganggu query backend
        // Kita juga pastikan nilai "0" (jika ada ID bernilai 0) tidak ikut terhapus
        const cleanParams = Object.fromEntries(
            Object.entries(params).filter(([, value]) => {
                return value !== "" && value !== null && value !== undefined;
            })
        );

        try {
            const res = await PromiseToPayService.get({ params: cleanParams });

            // Pastikan struktur response sesuai dengan Backend Laravel Resource
            // Biasanya: { data: [...], meta: {...} }
            const result = res?.data?.data ?? [];
            
            setData(Array.isArray(result) ? result : []);
            setMeta(res?.data?.meta ?? null);
            
        } catch (err) {
            console.error("Error fetching Promise To Pay:", err);
            setError(err?.response?.data || err);
        } finally {
            setLoading(false);
        }
    }, [params]); // Dependency params: akan re-fetch saat params berubah

    useEffect(() => {
        getData();
    }, [getData]);

    return {
        data,
        meta,
        loading,
        error,
        params,
        setParams,
        refreshData: getData,
    };
};